<template>
  <div class="detail_layout">
    <!--    <TitleBar :type=0></TitleBar>-->
    <template v-if="record != null">
      <div class="head called-box">
        <div class="circle"></div>
        <div class="left-box">
          <div class="people-img-box">
            <template v-if="record.mark && record.mark.tagType > 0">
              <img v-if="record.mark.tagType == 50" src="@/assets/icon_srdh.png"></img>
              <img v-else-if="record.mark.tagType == 51" src="@/assets/icon_fczj.png"></img>
              <img v-else-if="record.mark.tagType == 52" src="@/assets/icon_bxlc.png"></img>
              <img v-else-if="record.mark.tagType == 53" src="@/assets/icon_ggtx.png"></img>
              <img v-else-if="record.mark.tagType == 54" src="@/assets/icon_zpdh.png"></img>
              <img v-else-if="record.mark.tagType == 55" src="@/assets/icon_kdwm.png"></img>
              <img v-else-if="record.mark.tagType == 56" src="@/assets/icon_czc.png"></img>
              <img v-else src="@/assets/called.png"></img>
            </template>
            <template v-else>
              <img src="@/assets/called.png"></img>
            </template>
          </div>
        </div>

        <div class="right-box">
          <div class="right-top-box">
            <div class="phone-box">
              <div class="phone">{{ showName }}</div>
            </div>
          </div>
          <div class="msg">{{ record.callKey.callerPhoneNum }}
            <template v-if="record.contactInfo">{{ record.contactInfo.location }} {{ record.contactInfo.operator }}
            </template>
          </div>
        </div>
      </div>
      <div class="content" :class="{blur: status!=0}">
        <div class="msgs">
          <div class="date">
            {{ record.startTimeText }}
          </div>


          <template v-for="item in record.chatList">
            <template v-if="item.callerText">
              <div class="chat-bubble-box left">
                <img class="icon" src="@/assets/otherBubble.png" style="transform: scaleX(-1);">
                <div class="message splice" style="background: #fffff">{{ item.callerText }}</div>
                <div class="clear-float"></div>
              </div>
            </template>
            <template v-if="item.respText">
              <div class="chat-bubble-box right">
                <img class="icon" src="@/assets/meBubble.png">
                <div class="message splice">{{ item.respText }}</div>
                <div class="clear-float"></div>
              </div>
            </template>
          </template>


        </div>

        <div class="play_layout" :class="showExampleBottom ? 'play_layout_example' : ''" v-if="record.recordUrl">
          <img :src="isStore ? startIcon : stopIcon" @click="changeStart">
          <div class="play_tips">{{ play_tips }}</div>
          <audio :src="record.recordUrl" id="musicMp3" controls="" style="display: none"></audio>
        </div>

        <div class="bottom" v-if="!showExampleBottom">
          <template v-if="record.isexample">
            <div class="bottom_item" :href="smsUrl" @click="clickSms">
              <img src="@/assets/dosms.png">
              <div class="title">回复短信</div>
            </div>

            <div class="bottom_item" :href="dialUrl" @click="clickDial">
              <img src="@/assets/docall.png">
              <div class="title">拨打电话</div>
            </div>
          </template>
          <template v-else>
            <a class="bottom_item" :href="smsUrl" @click="clickSms">
              <img src="@/assets/dosms.png">
              <div class="title">回复短信</div>
            </a>

            <a class="bottom_item" :href="dialUrl" @click="clickDial">
              <img src="@/assets/docall.png">
              <div class="title">拨打电话</div>
            </a>
          </template>

        </div>
        <div v-else class="example_bottom">
          <img class="close_icon" src="@/assets/icon_close.png" @click="close_example">
          <div class="tip-title">
            你当前享有{{ leftCount }}次体验机会
          </div>
          <div class="tip2">
            购买会员无限次使用，解锁更多专属特权
          </div>
          <div class="btn-group-box btn-group-box-example">
            <div class="btn1" @click="vipPay">
              <img class="vipimg" src="@/assets/ic_vip.png">
              购买会员无限次使用
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="mask_view" v-if="status!=0">

      <div class="title-box">
        <div class="line left"></div>
        温馨提示
        <div class="line right"></div>
      </div>
      <template v-if="status==1">
        <div class="tip">
          近期3次免费查看机会已用完，开启会员服务可继续使用，快来了解一下吧
        </div>
        <div class="btn-group-box">
          <div class="btn1" @click="vipPay">
            <img class="vipimg" src="@/assets/ic_vip.png">
            开通会员服务
          </div>
        </div>
      </template>


      <template v-if="status==2">
        <div class="tip">
          您的接听助理服务体验已经到期，建议开通会员服务畅享无限次使用；或关闭服务避免运营商扣取您的呼转费用
        </div>
        <div class="btn-group-box">
          <div class="btn2" @click="closeService">
            关闭服务
          </div>

          <div class="btn3" @click="vipPay">
            <img class="vipimg" src="@/assets/ic_vip.png">
            开通会员
          </div>
        </div>
      </template>

      <template v-if="status==3">
        <div class="tip">
          你的服务已关闭，重新开启后查看话单
        </div>
        <div class="btn-group-box">
          <div class="btn4" @click="openService">
            重新开启服务
          </div>
        </div>
      </template>


    </div>
  </div>

</template>

<script>

import ic_play_icon from '@/assets/ic_play.png'
import ic_stop_icon from '@/assets/ic_pause.png'
import util from '@/utils/util'
import app from '@/AppData'
import lubanapi from '@/lubanApi'
import TitleBar from '@/components/widgets/TitleBar'
import {SERVICE_SWITCH} from '@/utils/const'
import jsbridge from '@/jsbridge'
import exampleCallList from '@/utils/exampleCallList'

const TAG = '[CallDetail]'

export default {
  inject: ['reload'],
  name: 'CallDetail',
  data () {
    return {
      record: null,
      dialUrl: '',
      smsUrl: '',
      isStore: true,
      perNumber: 0,
      startIcon: ic_play_icon,
      stopIcon: ic_stop_icon,
      play_tips: '播放录音',
      status: 0,
      vipInfo: {},
      canPlayListener: null,
      timeupdateListener: null,
      musicMp3: null,
      showName: '未知用户',
      showExampleBottom: false,
      leftCount: 0,
    }
  },
  components: {
    TitleBar
  },
  methods: {
    changeStart: function () {
      console.log('changeStart')
      if (typeof this.record.recordUrl == 'undefined' || this.record.recordUrl == null || this.record.recordUrl == '') {
        console.log('url empty')
        return
      }
      this.isStore = !this.isStore
      const musicMp3 = document.getElementById('musicMp3')
      if (!this.isStore) {
        musicMp3.play()
        console.log('musicMp3.play')
        lubanapi.reportseer('AICall_Bill_Details_Page_Play_Recording_Button_Click')
      } else {
        musicMp3.pause()
        console.log('musicMp3.pause')
      }
    },
    initEventListener () {
      let that = this
      this.canPlayListener = function () {
        that.updatePlayTips(that.musicMp3)
      }
      this.timeupdateListener = function () {
        const numbers = that.musicMp3.currentTime / that.musicMp3.duration
        let perNumber = (numbers * 100).toFixed(2)
        console.log('perNumber', perNumber)
        if (perNumber >= 100) {
          perNumber = 0
          that.isStore = true
        }
        that.perNumber = perNumber
        that.updatePlayTips(that.musicMp3)
      }
    },

    watchProgress: function () {
      const musicMp3 = document.getElementById('musicMp3')
      this.musicMp3 = musicMp3
      var that = this
      if (this.musicMp3 != null) {
        that.updatePlayTips(this.musicMp3)
        musicMp3.addEventListener('canplay', this.canPlayListener)
        musicMp3.addEventListener('timeupdate', this.timeupdateListener)
      }
    },
    updatePlayTips (musicMp3) {
      if (this.isStore) {
        console.log('this.perNumber', this.perNumber)
        if (this.perNumber == 0 || isNaN(this.preNumber)) {
          var mp3Duration = musicMp3.duration
          if (isNaN(mp3Duration)) {
            this.play_tips = '播放录音'
          } else {
            this.play_tips = '播放录音 ' + mp3Duration.toFixed(0) + 's'
          }
        } else {
          this.play_tips = '暂停 ' + musicMp3.currentTime.toFixed(0) + 's'
        }
      } else {
        this.play_tips = '播放中 ' + musicMp3.currentTime.toFixed(0) + 's'
      }
    },

    updateUI () {
      // 刷新UI
      if (this.vipInfo.vipStatus == 1) {
        // 正常显示
        this.status = 0
      } else {
        // 自己呼自己允许查看
        if (this.record.callKey.callerPhoneNum === app.getData().userSetting.phoneNum || this.record.isexample) {
          this.status = 0
        } else if (app.getLocalStorage(SERVICE_SWITCH.NAME) === SERVICE_SWITCH.STATE_CLOSE) {
          this.status = 3
          lubanapi.reportseer('AICall_Bill_Details_Page_Service_Close_Shown')
          // 超过体验次数，呼吁开vip
        } else if (app.isLimitRead()) {
          this.status = 2
        } else if (this.record.readStatus == 0) {
          this.status = 0
          lubanapi.reportseer('AICall_Bill_Details_Page_Shown_Not_Member_Not_First_View')
        } else {
          this.status = 1//
          lubanapi.reportseer('AICall_Bill_Details_Page_Service_Expire_New_Bill_Shown')
        }
      }
    },

    vipPay () {
      console.log('vipPay')
      jsbridge.openVip(this)
      lubanapi.reportseer('AICall_Bill_Details_Page_Service_Expire_New_Bill_Pay_Button_Click')
      lubanapi.reportseer('AICall_Goto_Member_Centre_Total', 'detail')
    },
    openService () {
      this.$router.push({
        name: 'bind_call_forward',
        params: {
          from: 'server'
        }
      })
      lubanapi.reportseer('AICall_Bill_Details_Page_Service_Close_Open_Service_Button_Click')
    },

    closeService () {
      this.$router.push({
        name: 'closeaipage'
      })
      lubanapi.reportseer('AICall_Bill_Details_Page_Service_Close_Open_Service_Button_Click')
    },

    // 非会员也可以已读
    reportCallRead () {
      if (this.record.readStatus == 0) {
        app.reportCallRead(this.record.callKey.sessionId)
        this.record.readStatus = 1
      }
    },

    updateShowName () {
      this.showName = '未知用户'
      if (this.record.contactInfo && this.record.contactInfo.name) {
        this.showName = this.record.contactInfo.name
      } else if (this.record.mark) {
        if (this.record.mark.tagType == 50) {
          this.showName = '骚扰电话'
        } else if (this.record.mark.tagType == 51) {
          this.showName = '房产中介'
        } else if (this.record.mark.tagType == 52) {
          this.showName = '保险理财'
        } else if (this.record.mark.tagType == 53) {
          this.showName = '广告推销'
        } else if (this.record.mark.tagType == 54) {
          this.showName = '诈骗电话'
        } else if (this.record.mark.tagType == 55) {
          this.showName = '快递外卖'
        } else if (this.record.mark.tagType == 56) {
          this.showName = '出租车'
        }
      }
    },

    clickSms () {
      lubanapi.reportseer('AICall_Bill_Details_Page_Reply_SMS_Button_Click')
      if (this.record.isexample) {
        util.Toast('示例话单，不支持本项操作', 3000)
      }
    },

    clickDial () {
      lubanapi.reportseer('AICall_Bill_Details_Page_Call_Back_Button_Click')
      if (this.record.isexample) {
        util.Toast('示例话单，不支持本项操作', 3000)
      }
    },

    close_example () {
      this.showExampleBottom = false
    }
  },
  mounted () {
    this.initEventListener()
  },
  activated () {
    let id = util.getUrlKey('id')
    let exampleNum = util.getUrlKey('exampleNum')
    if (exampleNum) {
      this.record = exampleCallList.getRecordByNum(exampleNum)
      if (!app.isVip()) {
        this.showExampleBottom = true
      } else {
        this.showExampleBottom = false
      }
      var recordSize = app.getData().calledList.recordList.length
      if (recordSize > 3) {
        this.leftCount = 0
      } else {
        this.leftCount = 3 - recordSize
      }
    } else {
      this.showExampleBottom = false
      this.record = app.getData().calledList.recordList[id]
    }

    console.log(TAG, 'id', id, 'exampleNum', exampleNum, this.record)

    this.isStore = true
    this.perNumber = 0

    this.dialUrl = 'tel:' + this.record.callKey.callerPhoneNum
    this.smsUrl = 'sms:' + this.record.callKey.callerPhoneNum
    this.vipInfo = app.getData().vipInfo

    // dom渲染后执行
    var that = this
    this.$nextTick(() => {
      that.watchProgress()
    })

    that.updateUI()

    this.reportCallRead()
    this.updateShowName()
    lubanapi.reportseer('AICall_Bill_Details_Page_Shown')
  },
  deactivated () {
    if (this.musicMp3 != null) {
      this.musicMp3.pause()
      this.musicMp3.currentTime = 0
    }
    this.showExampleBottom = false
  }
}
</script>

<style scoped>
.detail_layout {
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100%;
  width: 100%;
  background: #F7F7F9;
}

.msgs {
  flex: 1;
  background: #F7F7F9;
  width: 100%;
  height: auto;
  overflow-y: scroll;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 3rem;
  box-sizing: border-box;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow-y: scroll;
}

.msgs .date {
  width: 100%;
  height: auto;
  font-family: PingFangSC-Regular;
  font-size: 0.9rem;
  color: #999999;
  text-align: center;
  margin-top: 1rem;
}

.bottom {
  display: flex;
  flex-direction: row;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 3.75rem;
  width: 100%;
  background: white;
}

.example_bottom {
  height: 10.7rem;
  background: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  box-shadow: 0 0.2rem 0.6rem 0 rgba(0, 0, 0, 0.14);
  border-radius: 1.2rem 1.2rem 0 0;
  margin-top: 0.2rem;
}

.bottom_item {
  flex: 1;
  text-decoration: none;
}

a:link {
  /*font-size: 12px;*/
  color: #000000;
  text-decoration: none;
}

a:visited {
  /*font-size: 12px;*/
  color: #000000;
  text-decoration: none;
}

a:hover {
  /*font-size: 12px;*/
  color: #999999;
  text-decoration: none;
}

.bottom_item img {
  width: 1.9rem;
  height: 1.9rem;
}

.bottom_item .title {
  font-family: PingFangSC-Medium;
  font-size: 0.7rem;
  color: #444444;
  text-align: center;
}

.called-box {
  position: relative;
  width: 100%;
  height: 5.3rem;
  box-sizing: border-box;
  background: #ffffff;
}

.called-box .left-box {
  position: relative;
  width: 5.3rem;
  height: 5.3rem;
}

.called-box .left-box img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 1rem;
  width: 3.4rem;
  height: 3.4rem;
}

.called-box .right-box {
  position: absolute;
  width: calc(100% - 5.3rem);
  height: 5.3rem;
  top: 0px;
  right: 0;
  margin-top: 1rem;
  padding-right: 0.5rem;
  box-sizing: border-box;
}

.called-box .right-box .right-top-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2rem;
  box-sizing: border-box;
}

.called-box .right-box .right-top-box .phone-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 32px;
}

.called-box .right-box .right-top-box .phone-box .phone {
  float: left;
  width: 100%;
  color: #151515;
  text-align: left;
  height: 1.41rem;
  line-height: 1.41rem;
  font-family: PingFangSC-Medium;
  font-size: 1.2rem;
  color: #000000;
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.called-box .right-box .right-top-box .phone-box .phone-tag {
  float: left;
  margin-left: 12px;
  width: auto;
  height: 32px;
  padding: 0 6px;
  background: #000;
  opacity: 0.2;
  font-size: 20px;
  color: #fff;
  line-height: 32px;
  border-radius: 2.78px;
}

.called-box .right-box .right-top-box .date {
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
  height: 1rem;
  font-family: PingFangSC-Regular;
  font-size: 0.75rem;
  color: #999999;
  letter-spacing: 0;
  text-align: right;
}

.called-box .right-box .msg {
  position: absolute;
  left: 0;
  width: auto;
  font-size: 28px;
  color: #151515;
  text-align: left;
  word-break: break-all;
  overflow: hidden;

  top: 2rem;
  max-width: 100%;
  height: 1.25rem;
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: #999999;
  letter-spacing: 0;
}


.chat-bubble-box {
  position: relative;
  padding: 16px 0;
  width: 100%;
}

.left .message {
  float: left;
  background: #ffffff;
}

.right .message {
  float: right;
  background: #d1eaff;
}

.chat-bubble-box .icon {
  position: absolute;
  width: 16px;
  height: 16px;
}

.left .icon {
  left: 0;
}

.right .icon {
  right: 0;
}

.chat-bubble-box .message {
  margin: 0 16px;
  /*min-width: 28px;*/
  /*max-width: 582px;*/
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;
  color: #151515;
  word-break: break-all;

  text-align: left;
  line-height: 1.2rem;
  font-family: PingFangSC-Regular;
  font-size: 0.94rem;
  color: #151515;
}

.left .splice {
  border-top-left-radius: 0;
}

.right .splice {
  border-top-right-radius: 0;
}

.clear-float {
  clear: both;
}

.play_layout {
  position: absolute;
  right: 1.5rem;
  bottom: 5rem;
  width: 9rem;
  height: 2.5rem;
  border-radius: 1.25rem;
  background: #2289FF;
  display: flex;
  flex-direction: row;
  align-items: center; /* 垂直居中 */
}

.play_layout img {
  position: relative;
  width: 1.35rem;
  height: 1.35rem;
  margin-left: 0.6rem;
  margin-right: 0.4rem;
}

.play_layout .play_tips {
  color: #FFFFFF;
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  white-space: nowrap;
}

.play_layout_example {
  bottom: 11.6rem;
}

.mask_view {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  width: 100%;
  height: auto;
  border-radius: 15px;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #fff 5%);
  border-radius: 0.5rem;

  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.blur {
  filter: blur(5px);
}


.title-box {
  position: relative;
  width: 100%;
  opacity: 0.5;
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: #151515;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.title-box .line {
  top: 50%;
  transform: translateY(-50%);
  flex: 1;
  height: 2px;
  background: rgb(204, 204, 204);
  margin-left: 0.9rem;
  margin-right: 0.9rem;
}

.title-box .left {
  left: 60px;

}

.title-box .right {
  right: 60px;
}

.tip-title {
  font-size: 1.2rem;
  line-height: 1.6rem;
  color: black;
  width: 100%;
  text-align: center;
  margin-top: 1.3rem;
}

.tip2 {
  color: #999999;
  position: relative;
  width: 100%;
  padding-left: 10%;
  padding-right: 10%;
  height: auto;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 0.9rem;
  text-align: center;
  line-height: 0.9rem;
  margin-top: 0.6rem;
  margin-bottom: 0.6rem;
  box-sizing: border-box;
}

.tip {
  position: relative;
  width: 100%;
  padding-left: 10%;
  padding-right: 10%;
  height: auto;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 0.9rem;
  color: #151515;
  text-align: center;
  line-height: 1.6rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
}


.btn-group-box {
  position: relative;
  width: 90%;
  margin-left: 1rem;
  margin-right: 1rem;
  height: 2.8rem;
  box-sizing: border-box;
  margin-bottom: 4.7rem;
}

.btn-group-box .btn1 {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  border-radius: 0.2rem;
  box-sizing: border-box;
  background: #34384a;
  color: #ffe6a6;
  line-height: 2.8rem;
  font-size: 1rem;
  color: #FFE6A6;
  text-align: center;
  box-sizing: border-box;
}

.btn-group-box .btn2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 48%;
  height: 100%;
  border-radius: 0.2rem;
  box-sizing: border-box;
  background: #FFFFFF;
  color: #000000;
  line-height: 2.8rem;
  font-size: 1rem;
  background: #FFFFFF;
  border: 1px solid #34384A;
  border-radius: 0.2rem;
}

.btn-group-box .btn3 {
  position: absolute;
  top: 0;
  right: 0;
  width: 48%;
  height: 100%;
  border-radius: 0.2rem;
  box-sizing: border-box;
  background: #34384a;
  color: #ffe6a6;
  line-height: 2.8rem;
  font-size: 1rem;
  color: #FFE6A6;
  text-align: center;
  box-sizing: border-box;
}

.btn-group-box .btn4 {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border-radius: 0.2rem;
  box-sizing: border-box;
  background-image: linear-gradient(135deg, #5EDB3B 0%, #5DE588 100%);
  border-radius: 0.2rem;
  color: #ffe6a6;
  line-height: 2.8rem;
  font-size: 1rem;
  color: #FFE6A6;
  text-align: center;
  box-sizing: border-box;
  font-family: PingFangSC-Regular;
  color: #FFFFFF;
  margin-top: 1.4rem;
}


.btn-group-box .vip-pay {
  right: 0;
  background: #34384a;
  color: #ffe6a6;
  line-height: 2.8rem;
  font-size: 1rem;
  color: #FFE6A6;
  text-align: center;
  box-sizing: border-box;
  /*width: 100%;*/
}

.btn-group-box .vip-close {
  right: 0;
  background: #34384a;
  color: #ffe6a6;
  line-height: 2.8rem;
  font-size: 1rem;
  color: #FFE6A6;
  text-align: center;
  /*width: 100%;*/
}

.vipimg {
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 0.5rem;
  margin-bottom: 0.2rem;
}

.btn-group-box-example {
  margin-bottom: 1rem;
  margin-top: 1.4rem;
}

.close_icon {
  width: 2.2rem;
  height: 2.2rem;
  padding: 0.82rem 0.82rem 0.82rem 0.82rem;
  box-sizing: border-box;
  position: absolute;
  right: 0rem;
  margin-bottom: -1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/CallDetail.vue